import React, { Component } from 'react';
import Slider from '@mui/material/Slider';

import './slider.css';

class CustomSlider extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: this.props.value,
      sliderStyle: {
        margin: '0'
      }
    };
  }

  onChange = (event, newMinutes) => {
    this.setState({
      value: newMinutes
    });
  }

  onChangeCommitted = (event) => {
    this.props.onChange(this.state.value);
  }

  render() {
    return (
      <div className='custom-slider'>
        <div className='selected-value-container'>
          up to
          <span className='selected-value'>{this.state.value}</span>
          minutes read
        </div>

        <Slider 
          step={this.props.step} 
          min={this.props.min}  
          max={this.props.max}
          value={this.state.value}
          onChangeCommitted={this.onChangeCommitted}
          onChange={this.onChange}
          sliderStyle={this.state.sliderStyle} />

        <div className='slider-values-container'>
          <span className='range-value'>{this.props.min}</span>
          <span className='range-value'>{this.props.max}</span>
        </div>
      </div>
    );
  }
};

export default CustomSlider;